import { AUTH_SOURCE } from "../constants/authSource";
import { useGlobalStore } from "../context/UserContext/userContext";

/**
 * Patient auth flags (CRE hospital vs Radical embed).
 */
export function usePatientAuthFlags() {
  const authSource = useGlobalStore((s) => s.authSource);
  const creUser = useGlobalStore((s) => s.creUser);
  const radicalUser = useGlobalStore((s) => s.radicalUser);
  const isCreAuth = authSource === AUTH_SOURCE.CRE;
  const isRadicalAuth = authSource === AUTH_SOURCE.RADICAL;

  return {
    isCreAuth,
    isRadicalAuth,
    authSource,
    creUser,
    radicalUser,
  };
}
